// @flow
import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#0d47a1',
      contrastText: '#ffffff',
      '50': '#e2e9f4',
      '100': '#b6c8e3',
      '200': '#86a3d0',
      '300': '#567ebd',
      '400': '#3163af',
      '500': '#0d47a1',
      '600': '#0b4099',
      '700': '#09378f',
      '800': '#072f85',
      '900': '#072f85',
    },
    secondary: {
      main: '#ffbd53',
      contrastText: '#ffffff',
      '50': '#fff7ea',
      '100': '#ffebcb',
      '200': '#ffdea9',
      '300': '#ffd187',
      '400': '#ffc76d',
      '500': '#ffbd53',
      '600': '#ffb74c',
      '700': '#ffae42',
      '800': '#ffa639',
      '900': '#ff9829',
    },
    error: {
      main: '#ff0000',
      contrastText: '#ffffff',
      '50': '#ffe0e0',
      '100': '#ffb3b3',
      '200': '#ff8080',
      '300': '#ff4d4d',
      '400': '#ff2626',
      '500': '#ff0000',
      '600': '#ff0000',
      '700': '#ff0000',
      '800': '#ff0000',
      '900': '#ff0000',
    },
    grey: {
      '50': '#f2f2f2',
      '100': '#dedede',
      '200': '#c8c8c8',
      '300': '#b2b2b2',
      '400': '#a2a2a2',
      '500': '#919191',
      '600': '#898989',
      '700': '#7e7e7e',
      '800': '#747474',
      '900': '#626262',
    },
    success: {
      '50': '#eafaf1',
      '100': '#cbf2dc',
      '200': '#a8e9c5',
      '300': '#85e0ad',
      '400': '#6ada9c',
      '500': '#50d38a',
      '600': '#49ce82',
      '700': '#40c877',
      '800': '#37c26d',
      '900': '#27b75a',
    },
  },
  typography: {
    fontFamily: [
      '"Montserrat"',
      'Arial',
      'Tahoma',
      'sans-serif',
    ].join(','),
  },
});

export default theme;
